// extracted by mini-css-extract-plugin
export default {"label":"RadioDescription_label__1cy7x"};